module.exports = __webpack_public_path__ + "static/img/open-in-browser.e024c139.svg";